import { Box, Stack, Typography } from '@mui/material';
import { CasButton } from 'src/compass/shared/components';

interface LrpTypeProps {
  subTitle?: string;
  types: Array<{
    typeName: string;
    targetLowWeightLbs: number;
    targetHighWeightLbs: number;
  }>;
  selectedType: { typeName: string };
  onTypeChange: (type: any) => void;
}

export default function LrpTypeSelector({ subTitle, types, selectedType, onTypeChange }: LrpTypeProps) {
  return (
    <Stack flexDirection="row" justifyContent="space-around" mt={0} mb={1}>
      {types.length === 1 ? (
        <Box>
          <Typography className="lrp-tab-quoteType">
            {types[0].typeName} ({types[0].targetLowWeightLbs}-{types[0].targetHighWeightLbs}lbs)
          </Typography>
          <Typography className="subtitle">
            {subTitle}
          </Typography>
        </Box>
      ) : (
        types.map((type) => {
          const isSelected = selectedType.typeName === type.typeName;
          const selectedClassName = isSelected ? 'selected' : '';

          return (
            <CasButton
              key={type.typeName}
              className={`lrp-tab-quoteType-button ${selectedClassName}`}
              onClick={() => onTypeChange(type)}
            >
              <Typography className={`lrp-tab-quoteType-typeName ${selectedClassName}`}>
                {type.typeName}
              </Typography>
              <Typography className={`lrp-tab-quoteType-weights ${selectedClassName}`}>
                ({type.targetLowWeightLbs}-{type.targetHighWeightLbs}lbs)
              </Typography>
            </CasButton>
          );
        })
      )}
    </Stack>
  );
}
